module.exports = __webpack_public_path__ + "static/media/helix-footer.e50d59c9.svg";